import styled from 'styled-components'
import { TentativeScoringQuestionItemDesktop_ExamGradingQuestionFragment } from 'generated/graphql'
import TentativeScoringQuestionItemDesktop from './TentativeScoringQuestionItem.desktop'

interface TentativeScoringQuestionListDesktopProps {
  examGradingQuestions?: Array<TentativeScoringQuestionItemDesktop_ExamGradingQuestionFragment>
}

const TentativeScoringQuestionListDesktop = ({
  examGradingQuestions,
}: TentativeScoringQuestionListDesktopProps) => {
  return (
    <StyledWrapper>
      {examGradingQuestions?.map((question) => {
        return (
          <TentativeScoringQuestionItemDesktop
            key={`question-id-${question.id}-${question.seq}`}
            questionData={question}
          />
        )
      })}
    </StyledWrapper>
  )
}

export default TentativeScoringQuestionListDesktop

const StyledWrapper = styled.ul`
  width: 820px;
  display: flex;
  flex-direction: column;
  margin: 16px 0px 40px;
`
